import { useEffect, useState, useRef, useMemo } from 'react';
import { Card, Row, Col, Form, DatePicker, Button } from 'antd';
import { headerStyle, rowStyle } from 'shared/styles/baseStyle';
import EndPoints from 'shared/endPoints/EndPoints.json';
import { useHistory, useLocation } from 'react-router-dom';
import { getToday, isDateBefore20Dates } from 'shared/utils/dateUtils';
import moment from 'moment';
import NoLogin from './NoLogin';

export default function SearchNoLogin() {
  const { search } = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(search), [search]);
  const dateFormat = 'D/M/YYYY';
  const exportFormat = 'DD-MM-YYYY';
  const [endPoint, setEndPoint] = useState();
  const [form] = Form.useForm();
  const myRef = useRef();
  const history = useHistory();
  const [exportFilename, setExportTitle] = useState(
    `Anytime_BTMLoginReport_${getToday().today}_${getToday().today}`
  );
  const executeScroll = () =>
    myRef.current.scrollIntoView({ behavior: 'smooth' });
  const formItemLayout = {
    labelCol: {
      span: 10
    },
    wrapperCol: {
      span: 12
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      FromDate: queryParams.get('FromDate')
        ? moment(queryParams.get('FromDate'), dateFormat)
        : null
    });
    setExportTitle(
      `Anytime_BTMNoLoginStatusReport_${
        form.getFieldValue('FromDate')
          ? form.getFieldValue('FromDate')?.format(exportFormat)
          : getToday().today
      }`
    );
    setEndPoint(
      `${
        EndPoints.REPORTS.GETNOLOGIN
      }?${queryParams.toString()}`
    );
  }, [queryParams, form]);

  const onFinish = fieldsValues => {
    const values = {
      ...fieldsValues,
      FromDate: fieldsValues.FromDate?.format(dateFormat)
    };
    Object.keys(values).forEach(key =>
      values[key] === null || values[key] === undefined || values[key] === ''
        ? delete values[key]
        : values[key]
    );
    const params = new URLSearchParams(values);
    history.replace({ search: `?${params}` });
    setEndPoint(
      `${EndPoints.REPORTS.GETNOLOGIN}?${params}`
    );
    executeScroll();
  };

  return (
    <>
      <Card
        type="inner"
        headStyle={headerStyle}
        title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση"
      >
        <Row style={rowStyle}>
          <Col style={{ color: 'black' }} span={24}>
            Κριτήρια Αναζήτησης
          </Col>
        </Row>
        <Form {...formItemLayout} form={form} onFinish={onFinish}>
          <Row>
            <Col span={12}>
              <Form.Item
                name="FromDate"
                label="Ημερομηνία Από:"
                rules={[
                  {
                    required: true,
                    message: 'Το πεδίο είναι απαραίτητο'
                  }
                ]}
              >
                <DatePicker
                  disabledDate={isDateBefore20Dates}
                  data-testid="FromDate"
                  style={{ width: '70%' }}
                  format={dateFormat}
                />
              </Form.Item>
            </Col>
            <Col span={8} offset={10}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  style={{ backgroundColor: '#e6e6e6' }}
                >
                  Αναζήτηση
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      {endPoint?.includes('?FromDate=') && (
        <Col ref={myRef}>
          <NoLogin endPoint={endPoint} exportFilename={exportFilename} />
        </Col>
      )}
    </>
  );
}
